<template>
  <div class="floating text-xs-center">
    <v-menu open-on-hover offset-y>
      <template v-slot:activator="{ on }">
        <v-btn flat v-on="on">
          <v-badge overlap>
            <template v-slot:badge>
              <span v-if="count > 0">{{ count }}</span>
            </template>
            <v-icon color="#ff2e2e">notifications_active</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-list
        two-line
        style="max-height: 400px"
        class="scroll-y"
        v-if="this.count > 0"
      >
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          avatar
          @click="viewDetails(item.id, item.notify_type)"
        >
          <v-list-tile-avatar>
            <v-icon large color="primary">list_alt</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="item.message_title"></v-list-tile-title>
            <v-list-tile-sub-title
              v-html="item.message.substring(0, 35) + '..'"
            ></v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon ripple>
              <v-icon color="success">info</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-list v-else>
        <v-list-tile>
          <v-list-tile-title>No data found</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import axios from "axios";
import { ROOT_URL } from "@/api/connectingUrls";
import router from "../../router";
export default {
  data: () => ({
    items: [],
    count: 0,
    timer: "",
  }),

  created() {
    this.fetchData();
    this.timer = setInterval(this.fetchData, 300000);
  },

  methods: {
    // set data
    async fetchData() {
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          //perfectly is not call to base url
          return await axios
            .get(`${ROOT_URL}/${"fetch-notification-data"}`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // console.log(response);
              if (response.data.statusCode == 200) {
                this.items = response.data.data.datas;
                this.count = response.data.data.count;
              }
            });
        }
      } catch (error) {
        // console.log(error);
      }
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    // update data
    async viewDetails(itemId, notifiableType) {
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          //perfectly is not call to base url
          return await axios
            .get(`${ROOT_URL}/${"update-notification-data"}/${itemId}`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // console.log(response);
              if (response.data.statusCode == 200) {
                this.items = response.data.data.datas;
                this.count = response.data.data.count;
                if (notifiableType == 1) {
                  router.push("/cash-withdraw");
                } else if (notifiableType == 2) {
                  router.push("/mobile-recharge");
                } else if (notifiableType == 3 || notifiableType == 10) {
                  router.push("/project-list");
                } else if (notifiableType == 4) {
                  router.push("/payment-status");
                } else if (notifiableType == 5) {
                  router.push("/nagad-cashout");
                } else if (notifiableType == 6) {
                  router.push("/nid-status");
                } else if (notifiableType == 7) {
                  router.push("/team-management");
                } else if (notifiableType == 8) {
                  router.push("/agent-management");
                } else if (notifiableType == 12) {
                  router.push("/demo-request");
                } else if (notifiableType == 13) {
                  router.push("/balance-withdraw");
                } else if (notifiableType == 14) {
                  router.push("/subscription-package");
                } else {
                  router.push("/project-list");
                }
              }
            });
        }
      } catch (error) {
        // console.log(error);
      }
    },
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
  },
};
</script>
<style scoped>
.name {
  width: 100px; /* can be 100% ellipsis will happen when contents exceed it */
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.name:hover {
  white-space: wrap;
  /* or: 
  width: auto;
  */
}
</style>
